<template>
    <div>
        <ul class="assess-filter" >
            <li @click="yearClick" >{{yearSelected}}-{{yearSelected + 1}}<i class="iconfont icon-xia" ></i></li>
            <li @click="termClick" >{{termSelected == 1 ? '第一学期': '第二学期'}}<i class="iconfont icon-xia" ></i></li>
        </ul>
        <ul class="assess-quality-list"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="isMoreLoading"
            :infinite-scroll-immediate-check="true"
            infinite-scroll-distance="10">
            <router-link tag="li" :to="{ name: 'Assess-student-appeal-detail', query: {id : appeal.perHtmlId,appealId: appeal.appealId, userId : appeal.userId} }" v-for="(appeal,index) in appealList" :key="index" >
                <div class="msg-title-wrapper" >
                    <h4>{{appeal.content}}<i class="iconfont icon-delete" @click.stop="deleteRecord(appeal.appealId)" v-if="userInfo.userType != 2 || userInfo.isAdmin == 1 " ></i></h4>
                </div>
                <div class="msg-applier" >{{appeal.stuName}}（{{appeal.className}}）</div>
                <div class="msg-time" >
                    <span>{{appeal.time}}</span>
                    <span class="is-handle handled" v-if="appeal.type == 2" >已处理</span>
                    <span class="is-handle no-handle" v-else >未处理</span>
                </div>
            </router-link>
        </ul>

        <div class="loading-box" v-if="isLoading">
            <mt-spinner type="snake" class="loading-more"></mt-spinner>
            <span class="loading-more-txt">加载中...</span>
        </div>

        <div class="no-more" v-if="noMore">没有更多了~</div>

        <mt-popup
            v-model="popupVisible"
            position="bottom"
            class="assess-filter-type">
            <ul class="history-list list-gap" >
                <!-- 学年筛选 -->   
                <li @click="switchYear(value)" v-for="(value,key) in yearList" v-if="isShowYear" :key="key" >{{value}}-{{value + 1}}</li>
                <!-- 学期筛选 -->
                <li v-if="isShowTerm" @click="switchTerm(value)" v-for="(value,key) in termList" :key="key" >{{value == 1 ? '第一学期': '第二学期'}}</li>
            </ul>
        </mt-popup>

        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>
<script>
import Bottom from '../bottom.vue'
import { getUserInfo } from '../../service/user-service.js'
import { MessageBox } from 'mint-ui';
import Vue from 'vue'
import { Spinner, InfiniteScroll, Toast } from 'mint-ui'
Vue.use(InfiniteScroll)
Vue.component(Spinner.name, Spinner)
export default {
    data() {
        return {
            popupVisible: false,
            timeInfo: {},
            userInfo: {},
            yearSelected: '',
            termSelected: '',
            isShowYear: false,
            isShowTerm: false,
            yearList: [],
            termList: [1,2],
            appealList: [],               //申诉列表 
            isLoading: false, // 加载中转菊花
            isMoreLoading: true, // 加载更多中
            noMore: false, // 是否还有更多
            pageInfo: { // 分页信息
                page: 1,
                page_size: 10,
                total: 0, // 总条数
                totalPage: 1 // 总分页数
            }
        }
    },
    components: { Bottom },
    mounted () {
        this.$nextTick( () => {
            getUserInfo().then((user) => {
                this.timeInfo = user.nowYearAndTermAndMonth;
                this.userInfo = user.user;
                this.summaryClick = {
                    year: this.timeInfo.year,
                    term: this.timeInfo.term,
                    month: this.timeInfo.month
                }
                this.yearSelected = this.summaryClick.year;
                this.termSelected = this.summaryClick.term;
                this.getAppealData();
                for(let i = 0; i<5; i++) {
                    this.yearList.push(this.summaryClick.year - i);
                }
            });
        });
    },
    methods: {
        getAppealData(type) {
            this.$http.get('/api/mobile/devel/comment/getAppealList', {
                params: {
                    schoolId: this.userInfo.schoolId,
                    schoolYear: this.yearSelected,
                    eduPeriod: this.termSelected,
                    isAdmin: this.userInfo.isAdmin,
                    page: this.pageInfo.page,
                    rows: this.pageInfo.page_size,
                    objectId: this.userInfo.userId
                }
            }).then(res => {
                if(res.data.code == 0) {
                    if(type === 'loadMore') {
                        this.appealList = this.appealList.concat(res.data.data);
                    } else {
                        this.appealList = res.data.data;
                    }
                    // 设置分页
                    this.pageInfo.total = res.data.page.totalResult;
                    this.pageInfo.totalPage = Math.ceil(this.pageInfo.total / this.pageInfo.page_size);
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 2000
                    });
                }
                this.isLoading = false;
                this.isMoreLoading = false;
            })
        },
        loadMore () { // 加载更多
            this.pageInfo.page += 1 // 增加分页
            this.isMoreLoading = true // 设置加载更多中
            this.isLoading = true // 加载中
            if (this.pageInfo.page > this.pageInfo.totalPage) { // 超过了分页
                this.noMore = true // 显示没有更多了
                this.isLoading = false // 关闭加载中
                return false
            }
            // 做个缓冲
            setTimeout(() => {
                this.getAppealData('loadMore');
            }, 100)
        },
        yearClick() {
            this.popupVisible = true;
            this.isShowYear = true;
            this.isShowTerm = false;

        },
        switchYear(year) {
            this.yearSelected = year;
            this.popupVisible = false;
            this.isShowYear = false;
            this.getAppealData();
        },
        termClick() {
            this.popupVisible = true;
            this.isShowTerm = true;
            this.isShowYear = false;

        },
        switchTerm(term) {
            this.termSelected = term;
            this.popupVisible = false;
            this.isShowTerm = false;
            this.getAppealData();
        },
        // 删除当前申诉记录
        deleteRecord(id) {
            MessageBox.confirm('确定删除申诉？').then(res => {
                this.$http.get('/api/mobile/devel/comment/deleteAppeal', {
                    params: {
                        id: id
                    }
                }).then(res => {
                    if(res.data.code == 0) {
                        this.appealList = this.appealList.filter(item => {
                            return item.appealId != id;
                        })
                    }
                }).catch(() => {
                    console.log('取消');
                    return;
                })
            })
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/assessment/assess-student-appeal.vue